// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file travel/v1/common.proto (package travel.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AgencyInfo } from "../../agency/v1/agency_pb";
import { file_agency_v1_agency } from "../../agency/v1/agency_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Place } from "../../place/v1/place_pb";
import { file_place_v1_place } from "../../place/v1/place_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travel/v1/common.proto.
 */
export const file_travel_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agency_v1_agency, file_google_protobuf_timestamp, file_place_v1_place]);

/**
 * @generated from message travel.v1.Travel
 */
export type Travel = Message<"travel.v1.Travel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: travel.v1.Status status = 2;
   */
  status: Status;

  /**
   * @generated from field: travel.v1.Journey inward = 3;
   */
  inward?: Journey;

  /**
   * @generated from field: travel.v1.Journey outward = 4;
   */
  outward?: Journey;

  /**
   * @generated from field: repeated travel.v1.Product products = 5;
   */
  products: Product[];

  /**
   * @generated from field: repeated travel.v1.Ticket tickets = 6;
   */
  tickets: Ticket[];

  /**
   * @generated from field: repeated travel.v1.ProductPrice initial_prices = 7;
   */
  initialPrices: ProductPrice[];

  /**
   * @generated from field: repeated travel.v1.Passenger passengers = 8;
   */
  passengers: Passenger[];

  /**
   * @generated from field: string dap_number = 9;
   */
  dapNumber: string;

  /**
   * @generated from field: travel.v1.AmountDetails amount_details = 10;
   */
  amountDetails?: AmountDetails;

  /**
   * @generated from field: agency.v1.AgencyInfo agency_info = 12;
   */
  agencyInfo?: AgencyInfo;

  /**
   * @generated from field: optional google.protobuf.Timestamp confirmation_deadline = 13;
   */
  confirmationDeadline?: Timestamp;

  /**
   * @generated from field: optional bool is_exchangeable = 14;
   */
  isExchangeable?: boolean;

  /**
   * @generated from field: optional bool is_cancellable = 15;
   */
  isCancellable?: boolean;

  /**
   * @generated from field: optional travel.v1.RefundedDetailsAmount refunded_details = 16;
   */
  refundedDetails?: RefundedDetailsAmount;
};

/**
 * Describes the message travel.v1.Travel.
 * Use `create(TravelSchema)` to create a new message.
 */
export const TravelSchema: GenMessage<Travel> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 0);

/**
 * @generated from message travel.v1.RefundedDetailsAmount
 */
export type RefundedDetailsAmount = Message<"travel.v1.RefundedDetailsAmount"> & {
  /**
   * @generated from field: travel.v1.Price initial_price = 1;
   */
  initialPrice?: Price;

  /**
   * @generated from field: travel.v1.Price refunded_amount = 2;
   */
  refundedAmount?: Price;

  /**
   * @generated from field: travel.v1.Price refunded_out_of_pocket_amount = 3;
   */
  refundedOutOfPocketAmount?: Price;

  /**
   * @generated from field: travel.v1.Price refunded_caisse_amount = 4;
   */
  refundedCaisseAmount?: Price;

  /**
   * @generated from field: bool customer_refund_failed = 5;
   */
  customerRefundFailed: boolean;
};

/**
 * Describes the message travel.v1.RefundedDetailsAmount.
 * Use `create(RefundedDetailsAmountSchema)` to create a new message.
 */
export const RefundedDetailsAmountSchema: GenMessage<RefundedDetailsAmount> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 1);

/**
 * @generated from message travel.v1.AmountDetails
 */
export type AmountDetails = Message<"travel.v1.AmountDetails"> & {
  /**
   * @generated from field: string currency = 1;
   */
  currency: string;

  /**
   * @generated from field: int32 base_amount = 2;
   */
  baseAmount: number;

  /**
   * @generated from field: int32 agency_fees = 3;
   */
  agencyFees: number;

  /**
   * @generated from field: int32 included_taxes_agency_fees = 4;
   */
  includedTaxesAgencyFees: number;

  /**
   * @generated from field: int32 included_taxes_total_amount = 5;
   */
  includedTaxesTotalAmount: number;

  /**
   * @generated from field: int32 coverage_percentage = 6;
   */
  coveragePercentage: number;

  /**
   * @generated from field: int32 covered_amount = 7;
   */
  coveredAmount: number;

  /**
   * @generated from field: int32 out_of_pocket_amount = 8;
   */
  outOfPocketAmount: number;
};

/**
 * Describes the message travel.v1.AmountDetails.
 * Use `create(AmountDetailsSchema)` to create a new message.
 */
export const AmountDetailsSchema: GenMessage<AmountDetails> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 2);

/**
 * @generated from message travel.v1.Product
 */
export type Product = Message<"travel.v1.Product"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: repeated travel.v1.Condition conditions = 3;
   */
  conditions: Condition[];

  /**
   * @generated from field: string segment_id = 4;
   */
  segmentId: string;

  /**
   * @generated from field: string passenger_id = 5;
   */
  passengerId: string;

  /**
   * @generated from field: travel.v1.Accommodation accommodation = 6;
   */
  accommodation?: Accommodation;

  /**
   * @generated from field: travel.v1.CabinClass cabin_class = 7;
   */
  cabinClass?: CabinClass;

  /**
   * @generated from field: travel.v1.Flexibility flexibility = 8;
   */
  flexibility: Flexibility;

  /**
   * @generated from field: repeated travel.v1.Ancillary ancillaries = 9;
   */
  ancillaries: Ancillary[];

  /**
   * @generated from field: bool is_for_disabled_passenger = 10;
   */
  isForDisabledPassenger: boolean;
};

/**
 * Describes the message travel.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema: GenMessage<Product> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 3);

/**
 * @generated from message travel.v1.CabinClass
 */
export type CabinClass = Message<"travel.v1.CabinClass"> & {
  /**
   * @generated from oneof travel.v1.CabinClass.cabin_class
   */
  cabinClass: {
    /**
     * @generated from field: travel.v1.TrainCabinClass train_cabin_class = 1;
     */
    value: TrainCabinClass;
    case: "trainCabinClass";
  } | {
    /**
     * @generated from field: travel.v1.PlaneCabinClass plane_cabin_class = 2;
     */
    value: PlaneCabinClass;
    case: "planeCabinClass";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message travel.v1.CabinClass.
 * Use `create(CabinClassSchema)` to create a new message.
 */
export const CabinClassSchema: GenMessage<CabinClass> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 4);

/**
 * @generated from message travel.v1.Accommodation
 */
export type Accommodation = Message<"travel.v1.Accommodation"> & {
  /**
   * @generated from field: string seat = 1;
   */
  seat: string;

  /**
   * @generated from field: string coach = 2;
   */
  coach: string;
};

/**
 * Describes the message travel.v1.Accommodation.
 * Use `create(AccommodationSchema)` to create a new message.
 */
export const AccommodationSchema: GenMessage<Accommodation> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 5);

/**
 * @generated from message travel.v1.Ticket
 */
export type Ticket = Message<"travel.v1.Ticket"> & {
  /**
   * @generated from field: repeated string product_ids = 1;
   */
  productIds: string[];

  /**
   * @generated from field: string number = 2;
   */
  number: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;
};

/**
 * Describes the message travel.v1.Ticket.
 * Use `create(TicketSchema)` to create a new message.
 */
export const TicketSchema: GenMessage<Ticket> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 6);

/**
 * @generated from message travel.v1.ProductPrice
 */
export type ProductPrice = Message<"travel.v1.ProductPrice"> & {
  /**
   * @generated from field: travel.v1.Price price = 1;
   */
  price?: Price;

  /**
   * @generated from field: repeated string product_ids = 2;
   */
  productIds: string[];
};

/**
 * Describes the message travel.v1.ProductPrice.
 * Use `create(ProductPriceSchema)` to create a new message.
 */
export const ProductPriceSchema: GenMessage<ProductPrice> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 7);

/**
 * @generated from message travel.v1.Journey
 */
export type Journey = Message<"travel.v1.Journey"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: travel.v1.Schedule schedule = 2;
   */
  schedule?: Schedule;

  /**
   * @generated from field: travel.v1.Route route = 3;
   */
  route?: Route;

  /**
   * @generated from field: repeated travel.v1.Segment segments = 4;
   */
  segments: Segment[];

  /**
   * @generated from field: int32 ghg_emission = 5;
   */
  ghgEmission: number;

  /**
   * @generated from field: optional string connection_warning = 6;
   */
  connectionWarning?: string;
};

/**
 * Describes the message travel.v1.Journey.
 * Use `create(JourneySchema)` to create a new message.
 */
export const JourneySchema: GenMessage<Journey> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 8);

/**
 * @generated from message travel.v1.Carrier
 */
export type Carrier = Message<"travel.v1.Carrier"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string logo = 2;
   */
  logo: string;
};

/**
 * Describes the message travel.v1.Carrier.
 * Use `create(CarrierSchema)` to create a new message.
 */
export const CarrierSchema: GenMessage<Carrier> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 9);

/**
 * @generated from message travel.v1.Transport
 */
export type Transport = Message<"travel.v1.Transport"> & {
  /**
   * @generated from field: travel.v1.Transportation type = 1;
   */
  type: Transportation;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string number = 3;
   */
  number: string;

  /**
   * @generated from field: string logo = 4;
   */
  logo: string;
};

/**
 * Describes the message travel.v1.Transport.
 * Use `create(TransportSchema)` to create a new message.
 */
export const TransportSchema: GenMessage<Transport> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 10);

/**
 * @generated from message travel.v1.Segment
 */
export type Segment = Message<"travel.v1.Segment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: travel.v1.Route route = 2;
   */
  route?: Route;

  /**
   * @generated from field: travel.v1.Schedule schedule = 3;
   */
  schedule?: Schedule;

  /**
   * @generated from field: travel.v1.Carrier marketing_carrier = 4;
   */
  marketingCarrier?: Carrier;

  /**
   * @generated from field: travel.v1.Carrier operating_carrier = 5;
   */
  operatingCarrier?: Carrier;

  /**
   * @generated from field: travel.v1.Transport transport = 6;
   */
  transport?: Transport;

  /**
   * @generated from field: int32 ghg_emission = 7;
   */
  ghgEmission: number;
};

/**
 * Describes the message travel.v1.Segment.
 * Use `create(SegmentSchema)` to create a new message.
 */
export const SegmentSchema: GenMessage<Segment> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 11);

/**
 * @generated from message travel.v1.Schedule
 */
export type Schedule = Message<"travel.v1.Schedule"> & {
  /**
   * @generated from field: travel.v1.LocalDateTime departure = 1;
   */
  departure?: LocalDateTime;

  /**
   * @generated from field: travel.v1.LocalDateTime arrival = 2;
   */
  arrival?: LocalDateTime;

  /**
   * @generated from field: int32 duration = 3;
   */
  duration: number;
};

/**
 * Describes the message travel.v1.Schedule.
 * Use `create(ScheduleSchema)` to create a new message.
 */
export const ScheduleSchema: GenMessage<Schedule> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 12);

/**
 * @generated from message travel.v1.Route
 */
export type Route = Message<"travel.v1.Route"> & {
  /**
   * @generated from field: place.v1.Place origin = 1;
   */
  origin?: Place;

  /**
   * @generated from field: place.v1.Place destination = 2;
   */
  destination?: Place;
};

/**
 * Describes the message travel.v1.Route.
 * Use `create(RouteSchema)` to create a new message.
 */
export const RouteSchema: GenMessage<Route> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 13);

/**
 * @generated from message travel.v1.Offer
 */
export type Offer = Message<"travel.v1.Offer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof travel.v1.Offer.cabin_class
   */
  cabinClass: {
    /**
     * @generated from field: travel.v1.TrainCabinClass train_cabin_class = 2;
     */
    value: TrainCabinClass;
    case: "trainCabinClass";
  } | {
    /**
     * @generated from field: travel.v1.PlaneCabinClass plane_cabin_class = 3;
     */
    value: PlaneCabinClass;
    case: "planeCabinClass";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: travel.v1.Flexibility flexibility = 4;
   */
  flexibility: Flexibility;

  /**
   * @generated from field: travel.v1.Price initial_price = 5;
   */
  initialPrice?: Price;

  /**
   * @generated from field: travel.v1.Price subsidy_amount = 6;
   */
  subsidyAmount?: Price;

  /**
   * @generated from field: travel.v1.Price out_of_pocket_amount = 7;
   */
  outOfPocketAmount?: Price;

  /**
   * @generated from field: repeated travel.v1.PriceByPassenger prices = 8;
   */
  prices: PriceByPassenger[];

  /**
   * @generated from field: repeated travel.v1.ProductBySegmentsAndPassengers products = 9;
   */
  products: ProductBySegmentsAndPassengers[];

  /**
   * @generated from field: repeated travel.v1.Ancillary ancillaries = 10;
   */
  ancillaries: Ancillary[];

  /**
   * @generated from field: bool is_compliant = 11;
   */
  isCompliant: boolean;

  /**
   * @generated from field: bool is_passport_required = 12;
   */
  isPassportRequired: boolean;
};

/**
 * Describes the message travel.v1.Offer.
 * Use `create(OfferSchema)` to create a new message.
 */
export const OfferSchema: GenMessage<Offer> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 14);

/**
 * @generated from message travel.v1.Ancillary
 */
export type Ancillary = Message<"travel.v1.Ancillary"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;

  /**
   * @generated from field: travel.v1.Price price = 3;
   */
  price?: Price;
};

/**
 * Describes the message travel.v1.Ancillary.
 * Use `create(AncillarySchema)` to create a new message.
 */
export const AncillarySchema: GenMessage<Ancillary> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 15);

/**
 * @generated from message travel.v1.PriceByPassenger
 */
export type PriceByPassenger = Message<"travel.v1.PriceByPassenger"> & {
  /**
   * @generated from field: string passenger_id = 1;
   */
  passengerId: string;

  /**
   * @generated from field: travel.v1.Price price = 2;
   */
  price?: Price;
};

/**
 * Describes the message travel.v1.PriceByPassenger.
 * Use `create(PriceByPassengerSchema)` to create a new message.
 */
export const PriceByPassengerSchema: GenMessage<PriceByPassenger> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 16);

/**
 * @generated from message travel.v1.Price
 */
export type Price = Message<"travel.v1.Price"> & {
  /**
   * @generated from field: int64 amount = 1;
   */
  amount: bigint;

  /**
   * @generated from field: string currency = 2;
   */
  currency: string;
};

/**
 * Describes the message travel.v1.Price.
 * Use `create(PriceSchema)` to create a new message.
 */
export const PriceSchema: GenMessage<Price> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 17);

/**
 * @generated from message travel.v1.ProductBySegmentsAndPassengers
 */
export type ProductBySegmentsAndPassengers = Message<"travel.v1.ProductBySegmentsAndPassengers"> & {
  /**
   * @generated from field: repeated string segment_ids = 1;
   */
  segmentIds: string[];

  /**
   * @generated from field: repeated string passenger_ids = 2;
   */
  passengerIds: string[];

  /**
   * @generated from field: travel.v1.Product product = 3;
   */
  product?: Product;
};

/**
 * Describes the message travel.v1.ProductBySegmentsAndPassengers.
 * Use `create(ProductBySegmentsAndPassengersSchema)` to create a new message.
 */
export const ProductBySegmentsAndPassengersSchema: GenMessage<ProductBySegmentsAndPassengers> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 18);

/**
 * @generated from message travel.v1.Condition
 */
export type Condition = Message<"travel.v1.Condition"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message travel.v1.Condition.
 * Use `create(ConditionSchema)` to create a new message.
 */
export const ConditionSchema: GenMessage<Condition> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 19);

/**
 * @generated from message travel.v1.Placement
 */
export type Placement = Message<"travel.v1.Placement"> & {
  /**
   * @generated from field: string coach = 1;
   */
  coach: string;

  /**
   * @generated from field: string seat = 2;
   */
  seat: string;
};

/**
 * Describes the message travel.v1.Placement.
 * Use `create(PlacementSchema)` to create a new message.
 */
export const PlacementSchema: GenMessage<Placement> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 20);

/**
 * @generated from message travel.v1.UnnamedPassenger
 */
export type UnnamedPassenger = Message<"travel.v1.UnnamedPassenger"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * Format: YYYY-MM-DD
   *
   * @generated from field: string birth_date = 2;
   */
  birthDate: string;

  /**
   * @generated from field: string phone_number = 3;
   */
  phoneNumber: string;

  /**
   * @generated from field: repeated travel.v1.Card cards = 4;
   */
  cards: Card[];

  /**
   * @generated from field: optional travel.v1.Disability disability = 5;
   */
  disability?: Disability;

  /**
   * @generated from field: string id = 6;
   */
  id: string;

  /**
   * @generated from field: travel.v1.DisabilityCard has_companion_fare = 7;
   */
  hasCompanionFare: DisabilityCard;

  /**
   * @generated from field: optional string corsica_resident_number = 8;
   */
  corsicaResidentNumber?: string;

  /**
   * @generated from field: travel.v1.Gender gender = 9;
   */
  gender: Gender;

  /**
   * @generated from field: travel.v1.Passport passport = 10;
   */
  passport?: Passport;
};

/**
 * Describes the message travel.v1.UnnamedPassenger.
 * Use `create(UnnamedPassengerSchema)` to create a new message.
 */
export const UnnamedPassengerSchema: GenMessage<UnnamedPassenger> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 21);

/**
 * @generated from message travel.v1.Passenger
 */
export type Passenger = Message<"travel.v1.Passenger"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * Format: YYYY-MM-DD
   *
   * @generated from field: string birth_date = 4;
   */
  birthDate: string;

  /**
   * @generated from field: string phone_number = 5;
   */
  phoneNumber: string;

  /**
   * @generated from field: repeated travel.v1.Card cards = 6;
   */
  cards: Card[];

  /**
   * @generated from field: optional travel.v1.Disability disability = 7;
   */
  disability?: Disability;

  /**
   * @generated from field: string id = 8;
   */
  id: string;

  /**
   * @generated from field: travel.v1.DisabilityCard has_companion_fare = 9;
   */
  hasCompanionFare: DisabilityCard;

  /**
   * @generated from field: optional string corsica_resident_number = 10;
   */
  corsicaResidentNumber?: string;

  /**
   * @generated from field: travel.v1.Gender gender = 11;
   */
  gender: Gender;

  /**
   * @generated from field: travel.v1.Passport passport = 12;
   */
  passport?: Passport;
};

/**
 * Describes the message travel.v1.Passenger.
 * Use `create(PassengerSchema)` to create a new message.
 */
export const PassengerSchema: GenMessage<Passenger> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 22);

/**
 * @generated from message travel.v1.Passport
 */
export type Passport = Message<"travel.v1.Passport"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * @generated from field: string country_of_issue = 2;
   */
  countryOfIssue: string;

  /**
   * Format: YYYY-MM-DD
   *
   * @generated from field: string issue_date = 3;
   */
  issueDate: string;

  /**
   * Format: YYYY-MM-DD
   *
   * @generated from field: string expiry_date = 4;
   */
  expiryDate: string;
};

/**
 * Describes the message travel.v1.Passport.
 * Use `create(PassportSchema)` to create a new message.
 */
export const PassportSchema: GenMessage<Passport> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 23);

/**
 * @generated from message travel.v1.Card
 */
export type Card = Message<"travel.v1.Card"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: optional string number = 2;
   */
  number?: string;
};

/**
 * Describes the message travel.v1.Card.
 * Use `create(CardSchema)` to create a new message.
 */
export const CardSchema: GenMessage<Card> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 24);

/**
 * @generated from message travel.v1.Disability
 */
export type Disability = Message<"travel.v1.Disability"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: optional travel.v1.Wheelchair wheelchair = 2;
   */
  wheelchair?: Wheelchair;

  /**
   * @generated from field: bool needs_companion = 3;
   */
  needsCompanion: boolean;
};

/**
 * Describes the message travel.v1.Disability.
 * Use `create(DisabilitySchema)` to create a new message.
 */
export const DisabilitySchema: GenMessage<Disability> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 25);

/**
 * @generated from message travel.v1.Wheelchair
 */
export type Wheelchair = Message<"travel.v1.Wheelchair"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: travel.v1.Dimensions dimensions = 2;
   */
  dimensions?: Dimensions;

  /**
   * @generated from field: int32 weight = 3;
   */
  weight: number;

  /**
   * @generated from field: int32 wheel_thickness = 4;
   */
  wheelThickness: number;
};

/**
 * Describes the message travel.v1.Wheelchair.
 * Use `create(WheelchairSchema)` to create a new message.
 */
export const WheelchairSchema: GenMessage<Wheelchair> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 26);

/**
 * @generated from message travel.v1.Dimensions
 */
export type Dimensions = Message<"travel.v1.Dimensions"> & {
  /**
   * @generated from field: int32 length = 1;
   */
  length: number;

  /**
   * @generated from field: int32 width = 2;
   */
  width: number;

  /**
   * @generated from field: int32 height = 3;
   */
  height: number;
};

/**
 * Describes the message travel.v1.Dimensions.
 * Use `create(DimensionsSchema)` to create a new message.
 */
export const DimensionsSchema: GenMessage<Dimensions> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 27);

/**
 * @generated from message travel.v1.LocalDateTime
 */
export type LocalDateTime = Message<"travel.v1.LocalDateTime"> & {
  /**
   * @generated from field: int32 year = 1;
   */
  year: number;

  /**
   * @generated from field: int32 month = 2;
   */
  month: number;

  /**
   * @generated from field: int32 day = 3;
   */
  day: number;

  /**
   * @generated from field: int32 hours = 4;
   */
  hours: number;

  /**
   * @generated from field: int32 minutes = 5;
   */
  minutes: number;

  /**
   * @generated from field: int32 seconds = 6;
   */
  seconds: number;

  /**
   * @generated from field: int32 nanos = 7;
   */
  nanos: number;
};

/**
 * Describes the message travel.v1.LocalDateTime.
 * Use `create(LocalDateTimeSchema)` to create a new message.
 */
export const LocalDateTimeSchema: GenMessage<LocalDateTime> = /*@__PURE__*/
  messageDesc(file_travel_v1_common, 28);

/**
 * @generated from enum travel.v1.Status
 */
export enum Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_PRE_BOOKED = 1;
   */
  PRE_BOOKED = 1,

  /**
   * @generated from enum value: STATUS_BOOKING_IN_PROGRESS = 2;
   */
  BOOKING_IN_PROGRESS = 2,

  /**
   * @generated from enum value: STATUS_UPCOMING = 3;
   */
  UPCOMING = 3,

  /**
   * @generated from enum value: STATUS_IN_PROGRESS = 4;
   */
  IN_PROGRESS = 4,

  /**
   * @generated from enum value: STATUS_COMPLETED = 5;
   */
  COMPLETED = 5,

  /**
   * @generated from enum value: STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,
}

/**
 * Describes the enum travel.v1.Status.
 */
export const StatusSchema: GenEnum<Status> = /*@__PURE__*/
  enumDesc(file_travel_v1_common, 0);

/**
 * @generated from enum travel.v1.Transportation
 */
export enum Transportation {
  /**
   * @generated from enum value: TRANSPORTATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSPORTATION_TRAIN = 1;
   */
  TRAIN = 1,

  /**
   * @generated from enum value: TRANSPORTATION_PLANE = 2;
   */
  PLANE = 2,

  /**
   * @generated from enum value: TRANSPORTATION_BOAT = 3;
   */
  BOAT = 3,
}

/**
 * Describes the enum travel.v1.Transportation.
 */
export const TransportationSchema: GenEnum<Transportation> = /*@__PURE__*/
  enumDesc(file_travel_v1_common, 1);

/**
 * @generated from enum travel.v1.TrainCabinClass
 */
export enum TrainCabinClass {
  /**
   * @generated from enum value: TRAIN_CABIN_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAIN_CABIN_CLASS_FIRST = 1;
   */
  FIRST = 1,

  /**
   * @generated from enum value: TRAIN_CABIN_CLASS_SECOND = 2;
   */
  SECOND = 2,
}

/**
 * Describes the enum travel.v1.TrainCabinClass.
 */
export const TrainCabinClassSchema: GenEnum<TrainCabinClass> = /*@__PURE__*/
  enumDesc(file_travel_v1_common, 2);

/**
 * @generated from enum travel.v1.PlaneCabinClass
 */
export enum PlaneCabinClass {
  /**
   * @generated from enum value: PLANE_CABIN_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLANE_CABIN_CLASS_ECONOMY = 1;
   */
  ECONOMY = 1,

  /**
   * @generated from enum value: PLANE_CABIN_CLASS_ECONOMY_PREMIUM = 2;
   */
  ECONOMY_PREMIUM = 2,

  /**
   * @generated from enum value: PLANE_CABIN_CLASS_BUSINESS = 3;
   */
  BUSINESS = 3,
}

/**
 * Describes the enum travel.v1.PlaneCabinClass.
 */
export const PlaneCabinClassSchema: GenEnum<PlaneCabinClass> = /*@__PURE__*/
  enumDesc(file_travel_v1_common, 3);

/**
 * @generated from enum travel.v1.Flexibility
 */
export enum Flexibility {
  /**
   * @generated from enum value: FLEXIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FLEXIBILITY_NO_FLEX = 1;
   */
  NO_FLEX = 1,

  /**
   * @generated from enum value: FLEXIBILITY_SEMI_FLEX = 2;
   */
  SEMI_FLEX = 2,

  /**
   * @generated from enum value: FLEXIBILITY_FULL_FLEX = 3;
   */
  FULL_FLEX = 3,
}

/**
 * Describes the enum travel.v1.Flexibility.
 */
export const FlexibilitySchema: GenEnum<Flexibility> = /*@__PURE__*/
  enumDesc(file_travel_v1_common, 4);

/**
 * @generated from enum travel.v1.Gender
 */
export enum Gender {
  /**
   * @generated from enum value: GENDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENDER_MALE = 1;
   */
  MALE = 1,

  /**
   * @generated from enum value: GENDER_FEMALE = 2;
   */
  FEMALE = 2,

  /**
   * @generated from enum value: GENDER_NON_BINARY = 3;
   */
  NON_BINARY = 3,
}

/**
 * Describes the enum travel.v1.Gender.
 */
export const GenderSchema: GenEnum<Gender> = /*@__PURE__*/
  enumDesc(file_travel_v1_common, 5);

/**
 * @generated from enum travel.v1.DisabilityCard
 */
export enum DisabilityCard {
  /**
   * @generated from enum value: DISABILITY_CARD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISABILITY_CARD_DISABILITY_80_PERCENT = 1;
   */
  DISABILITY_80_PERCENT = 1,

  /**
   * @generated from enum value: DISABILITY_CARD_NEED_THIRD_PERSON = 2;
   */
  NEED_THIRD_PERSON = 2,

  /**
   * @generated from enum value: DISABILITY_CARD_BLINDNESS_GREEN_STAR = 3;
   */
  BLINDNESS_GREEN_STAR = 3,
}

/**
 * Describes the enum travel.v1.DisabilityCard.
 */
export const DisabilityCardSchema: GenEnum<DisabilityCard> = /*@__PURE__*/
  enumDesc(file_travel_v1_common, 6);

